// import React from "react";
// import { withToastManager } from "react-toast-notifications";

/**
 * Normalize toast body to a plain string (LQI-H01: objects/arrays were silent failures).
 * Never prefer raw stacks / Axios objects for shell failures — callers should pass
 * fixed copy via notifyShellLoadError.
 * @param {*} message
 * @returns {string}
 */
function normalizeToastMessage(message) {
    if (message == null || message === "") {
        return "";
    }
    if (typeof message === "string") {
        return message;
    }
    if (Array.isArray(message)) {
        return message.filter(Boolean).join(", ");
    }
    if (typeof message === "object") {
        if (message.error_messages) {
            return normalizeToastMessage(message.error_messages);
        }
        if (message.message) {
            return normalizeToastMessage(message.message);
        }
        // Do not JSON.stringify unknown error objects for end users.
        return "Something went wrong. Please try again.";
    }
    return String(message);
}

const ToastDemo = (toastManager, message, type) => {
    if (!toastManager) {
        return "";
    }
    const text = normalizeToastMessage(message);
    if (!text) {
        return "";
    }
    const appearance = type || "info";
    const isError = appearance === "error";
    return toastManager.add(text, {
        appearance: appearance,
        // LQI-H01: keep auth/error feedback until the user dismisses it.
        autoDismiss: !isError,
        autoDismissTimeout: isError ? 0 : 5000,
        pauseOnHover: true,
    });
};

/** Fixed user-facing copy for header / home / footer shell load failures (UI-016). */
var SHELL_LOAD_MESSAGES = {
    home: "We couldn’t load the home page. Please refresh and try again.",
    header_nav: "We couldn’t load the menu. Please refresh and try again.",
    header_notifications:
        "We couldn’t load notifications. Please try again later.",
    header_settings: "We couldn’t update that setting. Please try again.",
    footer: "We couldn’t load footer links. Some links may be unavailable.",
};

var recentShellToasts = {};
var SHELL_DEDUP_MS = 8000;

/**
 * Toast a safe, fixed shell-load error. Dedupes by key so parallel home
 * section failures do not spam the user.
 * @param {*} toastManager
 * @param {string} key  one of SHELL_LOAD_MESSAGES keys
 */
export function notifyShellLoadError(toastManager, key) {
    var message = SHELL_LOAD_MESSAGES[key] || SHELL_LOAD_MESSAGES.home;
    var now = Date.now();
    var last = recentShellToasts[key] || 0;
    if (now - last < SHELL_DEDUP_MS) {
        return "";
    }
    recentShellToasts[key] = now;
    return ToastDemo(toastManager, message, "error");
}

export default ToastDemo;
